const oneTrustToggleInfoDisplay = () => {
    $('.show-ot-infoDisplay, a[href$="#ot_toggleInfoDisplay"]').on('click', function(e){
        if(typeof OneTrust !== 'undefined') {
            e.preventDefault();

            OneTrust.ToggleInfoDisplay();
        }
    });
};

export default oneTrustToggleInfoDisplay;